











// vue
import { defineComponent, ref, watch, onBeforeMount } from '@vue/composition-api';

import EditorDropdown from '@/vue3/components/editor/EditorDropdown.vue';

export default defineComponent({
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        data: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Object,
            default: () => {},
        },
    },
    components: { EditorDropdown },
    setup(props: any, { emit }) {
        const localValue = ref<any>({ ...props.value });
        watch(localValue, (newValue) => {
            emit('input', newValue);
        }, { deep: true });

        const onInput = (selectedValue: any) => {
            const selectedOption = props.data.find(
                (x: any) => x[props.options.optionValue] == selectedValue,
            );
            localValue.value = {...localValue.value, 
                                   value: selectedValue, 
                                   displayValue: selectedOption ? selectedOption[props.options.optionLabel] : ''
                               };
        };

        const onLoad = () => {
            emit('input', {...props.value, operator: '=='})
        }

        onBeforeMount(()=>{
            onLoad();
        })

        return {
            localValue,
            onInput,
        };
    },
});
